/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import type { Unsubscribe } from '@amazon/vinyl-util'
import { installLazily } from '@/core/installLazily'
import type { KeyboardShortcutsDeps } from '@/transport/keyboardShortcuts'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('keyboardShortcuts')

/** {@link installGlobalKeyboardShortcuts}, loaded off the boot chunk. */
export function installGlobalKeyboardShortcutsLazy(deps: KeyboardShortcutsDeps): Unsubscribe {
    return installLazily(
        import('@/transport/keyboardShortcuts'),
        (m) => m.installGlobalKeyboardShortcuts(deps),
        errorHandler
    )
}
